// 퍼널/가입자 집계 헬퍼. 어드민 패널과 헤드리스 워커가 공유하는 순수 함수 모음.
import type { AdminQueryFilter } from '../admin-query.types';

export const STAGE_MILESTONES = [1, 3, 5, 7, 9, 10, 20, 30, 40, 50] as const;

/**
 * 여러 카운트를 순차로 부르는 패널(퍼널/출석 분포)에서 호출 사이에 두는 딜레이(ms).
 * V8 는 함수명당 초당 10회(sliding window)만 허용하므로, 각 호출(~90ms)에 더해
 * 넉넉히 쉬어 초당 호출 수를 ~4회로 낮춘다.
 */
export const ADMIN_COUNT_DELAY_MS = 250;

export const guestFilter = (): AdminQueryFilter => ({
  field: 'isGuest',
  operator: '==',
  value: true,
});

export const checkinFilter = (): AdminQueryFilter => ({
  field: 'attendance.checkInCount',
  operator: '>=',
  value: 1,
});

export const stageFilter = (n: number): AdminQueryFilter => ({
  field: 'lastClearedStageId',
  operator: '>=',
  value: n,
});

export const createdSinceFilter = (ms: number): AdminQueryFilter => ({
  field: 'createdAt',
  operator: '>=',
  value: ms,
});

export interface FunnelStepView {
  key: string;
  label: string;
  count: number;
}

export interface FunnelCounts {
  total: number;
  checkedIn: number;
  stageIncl: number[];
  stageMilestones: number[];
}

export function buildFunnelSteps(input: FunnelCounts): FunnelStepView[] {
  const steps: FunnelStepView[] = [
    { key: 'registered', label: '가입 완료', count: input.total },
    { key: 'checkin_1plus', label: '출석 1회+ (checkInCount≥1)', count: input.checkedIn },
  ];
  input.stageMilestones.forEach((n, i) => {
    steps.push({ key: `stage_${n}`, label: `Stage ${n}+ 클리어`, count: input.stageIncl[i] });
  });
  return steps;
}

export interface KpiSignupView {
  today: number;
  thisWeek: number;
  thisMonth: number;
}

export function buildKpiSignup(counts: KpiSignupView): KpiSignupView {
  return counts;
}
